<div
  *transloco="let t"
  class="search-filter-box-component popsy-button pill"
  [class.rtl]="rtlMode"
  [class.focus]="inFocus"
  [class.mobileL]="(biggerThan$ | async)?.mobileL"
  (click)="openSearchInput()">
  <popsy-icon-search-glass
    *ngIf="!query.length"
    class="search-icon"></popsy-icon-search-glass>
  <popsy-icon-remove
    *ngIf="query.length"
    (click)="getClearSearchQuery()"
    class="search-icon"></popsy-icon-remove>

  <div class="text" [class.rtl]="rtlMode">
    <ng-container *ngIf="searchType !== 'location'">
      <input
        data-clarity-unmask
        #searchField
        class="field search-field"
        [class.mobile]="(lessThan$ | async)?.mobileL && searchType !== 'location'"
        [class.focus]="inFocus"
        role="search"
        [attr.aria-label]="t('hint_search')"
        type="search"
        [placeholder]="t('hint_search')"
        [(ngModel)]="query"
        (focus)="inFocus = true"
        (focusout)="inFocus = false"
        (input)="valueChanged()" />
    </ng-container>
  </div>
</div>
